import React, { useEffect } from "react";
import { connect } from "react-redux";


const RecentIncidentSummary = ( props ) => {
  const {} = props;

  const incidents = [
      // {
      //   id: 1,
      //   label: "Attendance",
      //   count: 1,
      //   level: "minor",
      //   status: "Resolved",
      //   date: "2025-09-22",
      //   action: "Verbal reminder"
      // },
    ]
  
  	return (
      <div className="performance ">
          <div className="space-y-2">
            <h4 className="text-[12px] font-semibold gap-2 title-text">
              Recent Incidents
            </h4>
                {incidents.map((item) => (
                  <div key={item.id} className={`p-2 rounded-lg card-content title-text ${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    <div className="flex items-start justify-between mb-1">
                      <span className={`status-indicator ${item.level.toLowerCase().replace(/\s+/g, "-")} text-[8px]`}>{item.level}</span>
                      <span className="text-[8px]">{item.date}</span>
                    </div>
                    <p className="text-[10px] font-semibold">{item.label}</p>
                    <p className="text-[9px] mb-1">Late check-in (15 minutes)</p>
                    <div className="flex items-start justify-between mb-1">
                      <span className={`status-indicator ${item.status.toLowerCase().replace(/\s+/g, "-")} text-[8px]`}>{item.status}</span>
                      <span className="text-[8px]">{item.action}</span>
                    </div>
                  </div>
                ))}
          </div>
        </div>
);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(RecentIncidentSummary);
